import { DataSourceSetupComposite, enumATSModes } from "./DataSourceSetupComposite";
import { DATA_SOURCES_TEST_PREFIX } from "../Utils";
import { Checkbox } from "@theorgchartdev/storybook";
import { appcstr } from "@coreapp/utils/appcstr";

export const LeverSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const { requisitionStates } = config;
  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={importType !== "import"}
      showLoadHeaders={true}
      importType={importType}
      ATSType={enumATSModes.pureATS}
    >
      <Checkbox
        id={"toggle-sandbox"}
        data-testid={`${DATA_SOURCES_TEST_PREFIX}-lever-sandbox-checkbox`}
        label={appcstr("leverreqs")}
        size={"medium"}
        checked={requisitionStates}
        onChange={() => onChange({ ...config, requisitionStates: !requisitionStates })}
      />
    </DataSourceSetupComposite>
  );
};
